//ADMIN VIEWS
import Admin from '@/views/Admin'

const routes = [
    {
        path:'/admin',
        name: 'admin',
        component:Admin,
        meta: {
            title: 'MUCRISIS ༒ Panel de Administrador',
            layout: 'admin',
            metaTags: [
            {
                name: 'description',
                content: 'Página de administración del servidor Mu Crisis.'
            },
            {
                property: 'og:description',
                content: 'Página de administración del servidor Mu Crisis.'
            }
            ]
        }
    }
]

export default routes